module.exports = __webpack_public_path__ + "img/model_33.16e015b1.jpg";